import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { injectIntl } from "react-intl";
import { WithSearch } from "@elastic/react-search-ui";
import { ReactComponent as RemoveIcon } from "../../../assets/icons/close.svg";
import { hasProductBeenSelected } from "../../../utils/functions";
import { ClearFilters } from "./ClearFilters";
import { UIStateStoreContext } from "../../../stores/uiStateStore";
import { i18nConfig } from "../../../i18nConfig";
import { FilterOptionEnum, ServiceEnum } from "../../../models/dataModel";
const FilterComponent = injectIntl(({ intl, filters, filterName, removeFilter, clearFilters, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const filterCanBeRemoved = filterName !== intl.formatMessage({ id: "facets.product.allProducts" });
    const capitalizedName = filterName.substring(0, 1).toUpperCase() + filterName.substring(1);
    const filterLabel = capitalizedName === "Not version-specific"
        ? (!!i18nConfig.messages[intl.locale] &&
            i18nConfig.messages[intl.locale]["facets.software_version.notVersionSpecific"]) ||
            i18nConfig.messages[intl.defaultLocale]["facets.software_version.notVersionSpecific"]
        : capitalizedName;
    function remove() {
        const filterToRemove = filters.find((filter) => {
            return filter.values.includes(filterName);
        });
        const isCategoryFilter = filterToRemove?.field === FilterOptionEnum.CATEGORY;
        if (isCategoryFilter) {
            clearFilters();
            uiStore.setOpenCategory(undefined);
        }
        else {
            removeFilter(filterToRemove?.field, filterName);
        }
    }
    function handleKeyDown(event) {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            remove();
        }
    }
    return (_jsxs("div", { className: "filter", "data-testid": "selectedFilter", "aria-label": intl.formatMessage({ id: "icon.removeFilter.title" }) + ": " + filterLabel, tabIndex: filterCanBeRemoved ? 0 : -1, onKeyDown: filterCanBeRemoved ? handleKeyDown : undefined, children: [filterLabel, filterCanBeRemoved && (_jsx(RemoveIcon, { "aria-label": intl.formatMessage({ id: "icon.removeFilter.title" }), "data-testid": "removeFilterIcon", onClick: remove }))] }));
});
/**
 * Renders the header section with selected filters & 'Clear filters' button.
 */
export const SelectedFilters = injectIntl(({ intl }) => {
    const store = useContext(UIStateStoreContext);
    function getFilters(filters) {
        let allFilters = [];
        if (store.getOpenCategory() === ServiceEnum.TRIMBLE_HELP && !hasProductBeenSelected(filters)) {
            allFilters.push(intl.formatMessage({ id: "facets.product.allProducts" }));
        }
        (filters || []).forEach((filter) => {
            if (typeof filter.values === "string") {
                allFilters.push(filter.values);
            }
            else {
                if (filter.field === FilterOptionEnum.CATEGORY) {
                    allFilters.unshift(...filter.values);
                }
                else {
                    allFilters = allFilters.concat(filter.values);
                }
            }
        });
        return allFilters;
    }
    return (_jsx(WithSearch, { mapContextToProps: ({ filters, removeFilter, clearFilters }) => ({ filters, removeFilter, clearFilters }), children: ({ filters, removeFilter, clearFilters }) => (_jsx(Fragment, { children: getFilters(filters).length > 0 && (_jsxs("div", { className: "filter-list", "data-testid": "selectedFilters", children: [getFilters(filters).map((filterStr, i) => {
                        return (_jsx(FilterComponent, { filters: filters, filterName: filterStr, removeFilter: removeFilter, clearFilters: clearFilters }, i));
                    }), getFilters(filters).length > 0 && _jsx(ClearFilters, {})] })) })) }));
});
